import React from 'react';

const Dianomi = () => (
  <section className="more-stories-module post-more-stories">
    <div class="topBar" />
    <script
      type="text/javascript"
      id="dianomi_context_script"
      src="https://www.dianomi.com/js/contextfeed.js?id=76"
    />
    <div
      className="dianomi_context dianomiScriptContainer"
      data-dianomi-context-id="76"
    />
  </section>
);

export default Dianomi;
